<template>
  <modal id="warning_modal" v-model="show" title="Warning!"
         :before-close="beforeClose">
    <div>
      You are about to export <b>{{eventCount|numberWithCommas}}</b> events and that might take a long time. Are you
      sure you want to
      continue?
    </div>
    <div slot="footer">
      <btn v-on:click="onCancel">
        Cancel
      </btn>
      <btn class="float-right" type="primary" v-on:click="onConfirm">
        OK
      </btn>
    </div>
  </modal>
</template>
<script>
  export default {
    props: ['onCancel', 'onConfirm', 'eventCount', 'show'],
    name: 'warningModal',
    methods: {
      beforeClose () {
        return false
      }
    }
  }
</script>
<style>
</style>
